import React from 'react';
import { PublicationCardComponent } from '../publication-card-component/publication-card-component';
import { publications } from './publications';
import "./styles.css";

export const PublicationomponentV2 = () => (
	<React.Fragment>
        <div class="Experienceouter">
            <div class="title">
                <div class="focusSubTitle">
                    Publications
                </div>
                <div class="focusingSubContent">
                    My contributions to the research society and advancement to our future technologies.
                </div>
            </div>
            <div class="PublicationMain">
                {
                    publications.map((p)=>{
                        console.log(p)
                        return(
                            <PublicationCardComponent 
                                title={p.title}
                                img={p.img}
                                authorsFirstPart={p['authors-first-part']}
                                authorsSecondPart={p['authors-second-part']}
                                conference={p.conference}
                                summary={p.summary}
                                link={p.link}/>
                        )
                    })
                }
            </div>
        </div>
	</React.Fragment>
);